import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useRolesApi } from "../../http/roles/api";
import { UpsertRole } from "../../http/roles/types";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import RoleForm, { RoleFormBody } from "./RoleForm";

const NewRole: FC = () => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const rolesApi = useRolesApi();
  const navigate = useNavigate();

  const onSubmit = async (formData: RoleFormBody) => {
    const body: UpsertRole = {
      name: formData.name,
      permissions: formData.permissions,
      departments: formData.departments,
    };

    setIsSubmitting(true);
    try {
      const response = await rolesApi.insertAdminRole(body);
      dispatch(showSuccessNotification(i18n.t));
      navigate(`/admin/roles/${response.id}`);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.roles.new} />
      <Panel>
        <RoleForm isDisabled={isSubmitting} onSubmit={onSubmit} />
      </Panel>
    </>
  );
};

export default NewRole;
